export enum SlideTitle {
  'brand' = 'Brand new model',
  'hot' = 'Hot prices',
  'aloLike' = 'Also like',
}
